import 'url-search-params-polyfill';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import JanrainForm from '../Janrain/Janrain/HOC/JanrainForm';
import DoubleOptInVerification from '../Janrain/components/DoubleOptInVerification/DoubleOptInVerification';
export default function DoubleOptInVerificationBlock({
  document
}) {
  var _document$fields, _document$fields2, _document$fields3;
  const title = document == null ? void 0 : (_document$fields = document.fields) == null ? void 0 : _document$fields.title;
  const successText = document == null ? void 0 : (_document$fields2 = document.fields) == null ? void 0 : _document$fields2.successText;
  const failureText = document == null ? void 0 : (_document$fields3 = document.fields) == null ? void 0 : _document$fields3.failureText;
  useEffect(() => {}, []);
  return <JanrainForm needActiveSession={false}>
        <DoubleOptInVerification title={title} successText={successText} failureText={failureText}>
        </DoubleOptInVerification>
    </JanrainForm>;
}
DoubleOptInVerificationBlock.propTypes = {
  document: PropTypes.object
};